export const HEIDI_2_GETTING_STARTED_URL =
  'https://support.heidihealth.com/en/articles/14648425-getting-started-with-heidi-ii';
